import { Loader2, SearchX } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface IdLookupDropdownProps {
    id: string
    isLoading: boolean
    showAbove?: boolean
}

export const IdLookupDropdown = ({ id, isLoading, showAbove }: IdLookupDropdownProps) => {
    const { t } = useTranslation('common')

    return (
        <div
            className={cn(
                'absolute z-[10001] w-full bg-background border rounded-lg shadow-lg overflow-hidden',
                showAbove ? 'bottom-full mb-1' : 'top-full mt-1',
            )}
        >
            <div className="sticky top-0 bg-background border-b px-4 py-3 z-10">
                <h3 className="text-sm font-semibold text-foreground">
                    {t('formComponents.idLookupTitle')}
                </h3>
            </div>
            <div className="flex items-start gap-3 p-4 text-sm text-muted-foreground">
                {isLoading ? (
                    <>
                        <Loader2 className="w-4 h-4 animate-spin flex-shrink-0 mt-0.5" />
                        <div className="min-w-0">
                            <p className="truncate">{t('formComponents.idLookupLoading', { id })}</p>
                            <p className="text-xs mt-1">{t('formComponents.idLookupAutoHint')}</p>
                        </div>
                    </>
                ) : (
                    <>
                        <SearchX className="w-4 h-4 flex-shrink-0 mt-0.5" />
                        <span>{t('formComponents.idLookupNotFound')}</span>
                    </>
                )}
            </div>
        </div>
    )
}
